export const MOBILE_SEARCH_CONTROL_TITLE = "Packages";

export const MOBILE_SEARCH_CONTROL_CALENDAR_TITLE = "Choose dates";
